// extracted by mini-css-extract-plugin
export var activities = "Play-module--activities--69f8b";
export var activity = "Play-module--activity--4dbd4";
export var activityCarousel = "Play-module--activityCarousel--c3ca4";
export var container = "Play-module--container--508e8";